import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import fortyKRatings from "../../../../src/data/articles/cube-prospective-warhammer-40-000/40k-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  fortyKRatings,
  ProspectiveIntro,
  React
};